import React, { useEffect, useState } from 'react'
import { RedPraticaUSR } from '../../types/red'
import { praticheUsrApi } from '../../services/api'
import toast from 'react-hot-toast'

export interface SelectPraticaUSRValue {
  pratica_usr_id?: string
  nuova_pratica?: { numero_pratica: string; importo_approvato?: number }
  quota_percentuale?: number
}

interface Props {
  gruppo_id?: string | null
  value?: SelectPraticaUSRValue
  onChange: (value: SelectPraticaUSRValue) => void
}

const SelectPraticaUSR: React.FC<Props> = ({ gruppo_id, value, onChange }) => {
  const [pratiche, setPratiche] = useState<RedPraticaUSR[]>([])
  const [loading, setLoading] = useState(false)
  const [modo, setModo] = useState<'esistente' | 'nuova'>(
    value?.nuova_pratica ? 'nuova' : 'esistente'
  )
  const [numeroPratica, setNumeroPratica] = useState(value?.nuova_pratica?.numero_pratica || '')
  const [importo, setImporto] = useState(value?.nuova_pratica?.importo_approvato?.toString() || '')
  const [quota, setQuota] = useState(value?.quota_percentuale?.toString() || '')

  useEffect(() => {
    setLoading(true)
    praticheUsrApi.list(gruppo_id ?? undefined)
      .then(r => setPratiche(Array.isArray(r.data) ? r.data : []))
      .catch(() => toast.error('Errore caricamento pratiche USR'))
      .finally(() => setLoading(false))
  }, [gruppo_id])

  useEffect(() => {
    if (modo === 'esistente') {
      onChange({
        pratica_usr_id: value?.pratica_usr_id,
        quota_percentuale: quota ? parseFloat(quota) : undefined,
      })
    } else {
      onChange({
        nuova_pratica: {
          numero_pratica: numeroPratica,
          importo_approvato: importo ? parseFloat(importo) : undefined,
        },
        quota_percentuale: quota ? parseFloat(quota) : undefined,
      })
    }
  }, [modo, numeroPratica, importo, quota, value?.pratica_usr_id])

  return (
    <div className="space-y-3">
      <div>
        <label className="label">Pratica USR</label>
        <select
          className="input"
          value={modo}
          onChange={e => setModo(e.target.value as 'esistente' | 'nuova')}
        >
          <option value="esistente">Seleziona pratica esistente</option>
          <option value="nuova">+ Crea nuova pratica USR</option>
        </select>
      </div>

      {modo === 'esistente' && (
        <div>
          <select
            className="input"
            value={value?.pratica_usr_id || ''}
            onChange={e => {
              const pid = e.target.value
              onChange({
                pratica_usr_id: pid || undefined,
                quota_percentuale: quota ? parseFloat(quota) : undefined,
              })
            }}
            disabled={loading}
          >
            <option value="">-- Seleziona --</option>
            {Array.isArray(pratiche) && pratiche.map(p => (
              <option key={p.id} value={p.id}>
                {p.numero_pratica} {p.importo_approvato ? `(€${Number(p.importo_approvato).toLocaleString()})` : ''}
              </option>
            ))}
          </select>
          {value?.pratica_usr_id && Array.isArray(pratiche) && (
            <p className="text-xs text-gray-500 mt-1">
              Importo approvato: €{(() => {
                const importo = pratiche.find(p => p.id === value.pratica_usr_id)?.importo_approvato
                return importo != null ? Number(importo).toLocaleString() : '—'
              })()}
            </p>
          )}
        </div>
      )}

      {modo === 'nuova' && (
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label text-xs">Numero pratica</label>
            <input
              className="input"
              value={numeroPratica}
              onChange={e => setNumeroPratica(e.target.value)}
              placeholder="USR-2024-001"
            />
          </div>
          <div>
            <label className="label text-xs">Importo approvato (€)</label>
            <input
              type="number"
              className="input"
              value={importo}
              onChange={e => setImporto(e.target.value)}
              placeholder="0,00"
            />
          </div>
        </div>
      )}

      <div>
        <label className="label text-xs">Quota percentuale (%)</label>
        <input
          type="number"
          step="0.01"
          className="input"
          value={quota}
          onChange={e => setQuota(e.target.value)}
          placeholder="%"
        />
      </div>
    </div>
  )
}

export default SelectPraticaUSR
